import React from 'react';
import { MultipleCTASelection } from 'src/components';
import {
  Container,
  ContainerGutter,
  ContainerWrap,
  TextAppearance,
  Text,
  TextAlignment
} from '@volkswagen-onehub/components-core';
import { CTAsSiNo } from 'src/feature-app/InputsValues/CTAsObjects';

export const YaTienesVolkswagen = () => {
  return (
    <Container gutter={ContainerGutter.static400} wrap={ContainerWrap.always}>
      <MultipleCTASelection ctaValues={CTAsSiNo} name='cliente' ctaWidth='81' nextOnClick />
      <Text appearance={TextAppearance.copy200} textAlign={TextAlignment.left} staticSize>
        <sup >1</sup>{' '}Recuerda que para participar en el sorteo debes formar parte de la familia Volkswagen. 
      </Text>
    </Container>
  );
};
